import { __assign } from './__helpers/tslib/tslib.es6.js';
import AES from 'crypto-js/aes';

var configurations = {
    key: null,
    driver: AES,
};
function setEncryptionConfigurations(newConfigurations) {
    configurations = __assign(__assign({}, configurations), newConfigurations);
}
function getEncryptionConfig(key) {
    return configurations[key];
}

export { getEncryptionConfig, setEncryptionConfigurations };
